import React, { useEffect, useState } from "react";
import { Container, Button } from "reactstrap";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Autocomplete } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReplayIcon from "@mui/icons-material/Replay";
import { toast } from "react-toastify";
import { managementApprovalHistoryList } from "../../../api/requisition";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import dayjs from "dayjs";
import { fetchFilterListForAllocation } from "../../../api/approval";

const ManagementRequisitionHistory = () => {

  const dispatch = useDispatch();
  // dispatch(StorePageHeaderName("Requisition History"));

  document.title = "Requisition History";
  const [showList, setShowList] = useState(false);
  const [requisitionHistoryRows, setRequisitionHistoryRows] = useState([]);
  const [gridLoad, setGridLoad] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [productOptions, setProductOptions] = useState([]);

  useEffect(()=>{
    dispatch(StorePageHeaderName("Requisition History"));

  },[])

  const toggleList = () => {
    setShowList(!showList);
  };

  const columns = [
    {
      field: "sl_no",
      headerName: "Sl.No",
      width: 70,
      esizable: false,
      sortable: false,
    },
    // {
    //   field: "approve_date",
    //   headerName: "Approve Date",
    //   headerClassName: "break-header",
    //   cellClassName: "product_name_wrap",
    //   width: 160,
    //   sortable: false,
    //   resizable: false,
    //   flex: 1,
    // },
    {
      field: "vendor_name",
      headerName: "Vendor Name",
      headerClassName: "break-header",
      cellClassName: "product_name_wrap",
      width: 160,
      sortable: false,
      resizable: false,
      flex: 1,
    },
    {
      field: "segment",
      headerName: "Segment",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "category",
      headerName: "Category",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "vertical",
      headerName: "Vertical",
      headerClassName: "table-header-background",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "product_name",
      headerName: "Product Name",
      headerClassName: "break-header",
      cellClassName: "management_product_name_wrap",
      width: 200,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "Req_qty",
      headerName: "REQ QTY",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
    {
      field: "approved_qty",
      headerName: "Approved QTY",
      sortable: false,
      resizable: false,
      headerClassName: "break-header",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      width: 130,
      flex: 1,
    },
    {
      field: "remaining_qty",
      headerName: "Remaining QTY",
      headerClassName: "break-header",
      cellClassName: "center-aligndata",
      width: 130,
      sortable: false,
      resizable: false,
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "added_qty",
      headerName: "Added QTY",
      headerClassName: "break-header",
      cellClassName: "center-aligndata",
      width: 130,
      sortable: false,
      resizable: false,
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "value",
      headerName: "Value",
      headerClassName: "table-header-background",
      sortable: false,
      resizable: false,
      headerAlign: "center",
      cellClassName: "center-aligndata",
      flex: 1,
    },
  ];

  const requisitionHistoryList = async (
    product = null,
    vendor = null,
    start_date = null,
    end_date = null
  ) => {
    try {
      setGridLoad(true);
      const payload = {
        product,
        vendor,
        start_date,
        end_date,
      };
      const response = await managementApprovalHistoryList(payload);
      const data = response.data.approvalHistory.map((item, index) => ({
        id: item.id,
        sl_no: index + 1,
        approve_date: item.approve_date.split('T')[0],
        vendor_name: item.v_name,
        segment: item.itemseg,
        category: item.category,
        vertical: item.vertical,
        product_name: item.item_name,
        po_qty: item.total_qty,
        approved_qty: item.approve_quantity,
        remaining_qty: +item.total_qty - +item.approve_quantity,
        value: item.mop,
      }));
      setRequisitionHistoryRows(data);
    } catch (error) {
      toast.error(
        error.message || "An error occurred while fetching the approval list"
      );
    } finally {
      setGridLoad(false);
    }
  };

  const fetchFilterList = async () => {
    try {
      const list = await fetchFilterListForAllocation({
        filter_type: ["vendor", "product"],
        isManagementHistory: 'managementHistory'
      });
      if (list.statusCode === 200) {
        if (list.data.response.productList.length > 0) {
          setProductOptions(list.data.response.productList);
        }
        if (list.data.response.vendorList.length > 0) {
          setVendorOptions(list.data.response.vendorList);
        }
      }
    } catch (error) {
      toast.error("Error in fetching filter list");
      console.log(error);
    }
  };

  const handleStartDateChange = (startDate) => {
    try {
      if (
        selectedEndDate &&
        startDate &&
        dayjs(startDate).isAfter(dayjs(selectedEndDate))
      ) {
        throw new Error("Start date cannot be after end date");
      }
      setSelectedStartDate(startDate);
    } catch (err) {
      setSelectedStartDate(null);
      toast.error(err.message);
    }
  };

  const handleEndDateChange = (endDate) => {
    try {
      if (
        selectedStartDate &&
        endDate &&
        dayjs(endDate).isBefore(dayjs(selectedStartDate))
      ) {
        throw new Error("End date cannot be before start date");
      }
      setSelectedEndDate(endDate);
    } catch (err) {
      setSelectedEndDate(null);
      toast.error(err.message);
    }
  };

  const handleSearch = () => {
    try {
      const product = selectedProduct ? selectedProduct.value : null;
      const vendor = selectedVendor ? selectedVendor.value : null;
      const start_date = selectedStartDate
        ? dayjs(selectedStartDate).format("YYYY-MM-DD")
        : null;
      const end_date = selectedEndDate
        ? dayjs(selectedEndDate).format("YYYY-MM-DD")
        : null;
      if (product || vendor || (start_date && end_date)) {
        requisitionHistoryList(product, vendor, start_date, end_date);
      } else {
        throw new Error("Please select proper search parameter.");
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleReset = () => {
    setSelectedProduct(null);
    setSelectedVendor(null);
    setSelectedStartDate(null);
    setSelectedEndDate(null);
    requisitionHistoryList();
  };

  useEffect(() => {
    if (showList) {
      fetchFilterList();
    }
  }, [showList]);

  useEffect(() => {
    requisitionHistoryList();
  }, []);
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <div>
                <h4 className="mb-0 requisition_text">History</h4>
              </div>
              <div>
                <button onClick={toggleList} className="filter_button">
                  <span className="me-2">
                    <TuneIcon />
                  </span>
                  Filter
                </button>
              </div>
            </div>
            {showList && (
              <div
                className="mt-2 mb-2"
                style={{
                  display: "flex",
                  gap: "10px",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={productOptions}
                    sx={{ width: 210 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Product" />
                    )}
                    onInputChange={(event, newValue) => {
                      const getVal = productOptions.find(
                        (el) => el.label === newValue
                      );
                      setSelectedProduct(getVal || null);
                    }}
                    onChange={(event, newValue) => {
                      setSelectedProduct(newValue || null);
                    }}
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    value={selectedProduct}
                  />
                </div>
                <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={vendorOptions}
                    sx={{
                      width: 190,
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Select Vendor" />
                    )}
                    onInputChange={(event, newValue) => {
                      const getVal = vendorOptions.find(
                        (el) => el.label === newValue
                      );
                      setSelectedVendor(getVal || null);
                    }}
                    onChange={(event, newValue) => {
                      setSelectedVendor(newValue || null);
                    }}
                    getOptionLabel={(option) => option?.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option?.value === value?.value
                    }
                    value={selectedVendor}
                  />
                </div>
                <div className="d-flex">
                  <div>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        className="date_picker"
                        label="From Date"
                        value={selectedStartDate}
                        onChange={handleStartDateChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                  <div className="ms-2">
                    <LocalizationProvider
                      className="date_picker"
                      dateAdapter={AdapterDayjs}
                    >
                      <DatePicker
                        className="date_picker"
                        label="To Date"
                        value={selectedEndDate}
                        onChange={handleEndDateChange}
                        renderInput={(params) => <TextField {...params} />}
                      />
                    </LocalizationProvider>
                  </div>
                </div>
                {/* <div>
                  <Autocomplete
                    className="data_field"
                    disablePortal
                    id="combo-box-demo"
                    options={productList}
                    sx={{ width: 170 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Status" />
                    )}
                  />
                </div> */}
                <div>
                  <Button
                    className="me-2"
                    variant="outlined"
                    onClick={handleSearch}
                  >
                    Search
                  </Button>
                  <ReplayIcon onClick={handleReset} />
                </div>
              </div>
            )}
            <Box sx={{ height: "100%", width: "100%", marginBottom: "10px" }}>
              <DataGrid
                autoHeight
                className="table_header_background"
                headerClassName="custom-header-cell"
                rows={requisitionHistoryRows}
                columns={columns}
                loading={gridLoad}
                getRowHeight={() => "auto"}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                }}
                pageSizeOptions={[5]}
                disableRowSelectionOnClick
                disableColumnMenu
                componentsProps={{
                  cell: {
                    disableClick: true,
                  },
                }}
              />
            </Box>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ManagementRequisitionHistory;
